let googlePermissionsHtml = `<div style="text-align: left;" class='contentHolder'>
        <h2 style="font-weight: bold;">Let’s Connect Your Google Account</h2>

<p style="font-weight: bold; text-align: left;">Why We Need Access to Your Data:</p>

<ul>
    <li><span style="font-weight: bold;">GA4:</span> Assign and filter annotations; view beautiful, user-friendly reports.</li>
    <li><span style="font-weight: bold;">Search Console:</span> View attractive reports on our dashboard.</li>
    <li><span style="font-weight: bold;">Tag Manager:</span> Auto-create annotations with script updates.</li>

</ul>
<br />
<p style="font-weight: bold; text-align: left;">Privacy & Security:</p>

<ul>
    <li><span style="font-weight: bold;">Privacy:</span> Your data is not shared; it's only used to enhance tool functionality.</li>
    <li><span style="font-weight: bold;">Security:</span> Data is encrypted; ISO27001</li>
</ul>
        </div>`;


export default googlePermissionsHtml;
